import React from "react";
import { OvertimeTable } from "components/table/overtime/OvertimeTable";

const Overtimes = () => {

    return (
        <>
            <OvertimeTable/>
        </>
    )
}

export { Overtimes }